export const allowedPlans = [
    "inicial",
    "basico",
    "empresarial",
    "ultimate",
  ];